import css from './index.module.css';
import { Link, useLocation } from "react-router-dom";
import useUserData from "@hooks/useUserData";
import { useEffect, useState } from 'react';

const Menu = () => {
    const location = useLocation();
    const { cartData, userData } = useUserData();
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

    const cartCount = Math.ceil(
        Array.isArray(cartData)
            ? cartData.reduce((sum: number, item: any) => sum + (item?.count || 0), 0)
            : 0
    );

    const isActive = (path: any) => {
        const regex = new RegExp(`^${path.replace(/:\w+/g, '\\w+')}$`);
        return regex.test(location.pathname);
    };

    useEffect(() => {
        const handleFocusIn = (e: Event) => {
            const target = e.target as HTMLElement | null;
            if (!target) return;
            const tag = target.tagName.toLowerCase();
            const isEditable = (target as HTMLElement).isContentEditable;
            if (tag === 'input' || tag === 'textarea' || isEditable) {
                setIsKeyboardOpen(true);
            }
        };

        const handleFocusOut = () => {
            // Delay slightly to avoid flicker when switching inputs
            setTimeout(() => setIsKeyboardOpen(false), 150);
        };

        const vv = (window as any).visualViewport as VisualViewport | undefined;
        const initialHeight = window.innerHeight;
        const handleViewport = () => {
            if (!vv) return;
            const height = vv.height;
            const keyboardLikelyOpen = initialHeight - height > 150; // heuristic
            setIsKeyboardOpen(keyboardLikelyOpen);
        };

        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);
        if (vv) {
            vv.addEventListener('resize', handleViewport);
            vv.addEventListener('scroll', handleViewport);
        }

        return () => {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
            if (vv) {
                vv.removeEventListener('resize', handleViewport);
                vv.removeEventListener('scroll', handleViewport);
            }
        };
    }, []);

    return (
        <div className={css.menu} style={{ transform: isKeyboardOpen ? 'translateY(100%)' : 'translateY(0)', transition: 'transform 150ms ease' }}>
            <div className={css.menuContent}>
                <Link to={`/webapp`} className={location.pathname === '/webapp' || isActive('/webapp/product/:id') ? css.active : ''}>
                    <i className="fi fi-rr-home"></i>
                </Link>

                <Link to={`/webapp/cart`} className={location.pathname === '/webapp/cart' || isActive('/webapp/cart') ? css.active : ''}>
                    <div style={{ position: 'relative' }}>
                        <i className="fi fi-rr-shopping-cart"></i>
                        {cartCount > 0 && (
                            <span
                                style={{
                                    position: 'absolute',
                                    top: -6,
                                    right: -10,
                                    background: '#ef4444',
                                    color: '#fff',
                                    borderRadius: 9999,
                                    padding: '2px 2px',
                                    fontSize: 12,
                                    lineHeight: '16px',
                                    minWidth: 16,
                                    textAlign: 'center',
                                    fontWeight: 700
                                }}
                            >{cartCount}</span>
                        )}
                    </div>
                </Link>

                <Link to={`/webapp/favorites`} className={location.pathname === '/webapp/favorites' || isActive('/webapp/favorites') ? css.active : ''}>
                    <i className="fi fi-rr-heart"></i>
                </Link>

                <Link to={`/webapp/chats`} className={location.pathname === '/webapp/chats' || isActive('/webapp/chats') ? css.active : ''}>
                    <div style={{ position: 'relative' }}>
                        <i className="fi fi-rr-messages"></i>
                        {!userData.isChatRead && (
                            <div className={css.unreadBadge} />
                        )}
                    </div>
                </Link>

                <Link to={`/webapp/user`} className={location.pathname === '/webapp/user' || isActive('/webapp/user') ? css.active : ''}>
                    <div style={{ position: 'relative' }}>
                        <i className="fi fi-rr-circle-user"></i>
                        {userData.unreadNotifications > 0 && (
                            <div className={css.unreadBadge} />
                        )}
                    </div>
                </Link>

                {userData.access == 1 && (
                    <Link to={`/manage`} className={location.pathname === '/manage' || isActive('/manage') ? css.active : ''}>
                        <i className="fi fi-rr-settings"></i>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default Menu;